import React from 'react';
import PropTypes from 'prop-types';
import EmailInputComponent from './EmailInputComponent';
import parse from 'html-react-parser';

const SpecialOfferDescription = ({
  stackOnLarge = false, header = 'Special Offer Description',
  subheader = `
    Enter your email to receive your promo code for a free one-way luggage shipment with any round-trip booking.
  `,
  buttonText = 'Claim Offer',
}) => {
  const positioningClasses = stackOnLarge ? '' : 'max-w-7xl xl:flex-row xl:items-start xl:gap-16';
  const emailInputClasses = stackOnLarge ? 'mt-6 lg:mt-10 max-w-[678px]' : 'mt-6 xl:w-1/2';
  const divPositioningClasses = stackOnLarge ? '' : 'xl:text-left xl:w-1/2';

  return (
    <div className="px-8 py-14 lg:px-24 xl:px-44 2xl:px-60 lg:py-16 bg-[#49C44F] w-full">
      <div className={`mx-auto flex flex-col items-center ${positioningClasses}`}>
        <div className={`flex flex-col text-center justify-center gap-4 ${divPositioningClasses}`}>
          <h2 className="text-4xl font-bold text-white leading-tight">
            {parse(header)}
          </h2>
          <p className="text-lg font-semibold text-white leading-normal">
            {parse(subheader)}
          </p>
        </div>
        <EmailInputComponent
          id="2"
          buttonText={buttonText || 'Claim Offer'}
          className={`${emailInputClasses} w-full sm:w-11/12 md:w-4/5`}
          buttonBgColor="#1C2938"
        />
      </div>
    </div>
  );
};

SpecialOfferDescription.propTypes = {
  stackOnLarge: PropTypes.bool,
  header: PropTypes.string,
  subheader: PropTypes.string,
  buttonText: PropTypes.string
};

export default SpecialOfferDescription;
